import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=c60d99c8&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=c60d99c8&prod&lang=stylus"
import style1 from "./GoodsInfo.vue?vue&type=style&index=1&id=c60d99c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d99c8",
  null
  
)

export default component.exports